<template>
    <QuickpayPaymentLayout @back="$emit('back')">
        <template #description>
            <QuickpayPaymentOverviewDescription
                type="payment"
                class="quickpay-payment-overview-card__description"
            />
        </template>
        <template #main-content>
            <QuickpayPaymentStripe
                :hash="hash"
                :deadlineId="deadlineId"
                class="quickpay-payment-overview-card__provider"
                @payment-success="$emit('payment-success')"
            />
        </template>
    </QuickpayPaymentLayout>
</template>

<script>
import QuickpayPaymentLayout from 'vcomponents/quickpay/payment/QuickpayPaymentLayout.vue';
import QuickpayPaymentStripe from 'vcomponents/quickpay/payment/stripe/QuickpayPaymentStripe.vue';
import QuickpayPaymentOverviewDescription from 'vcomponents/quickpay/payment/QuickpayPaymentOverviewDescription.vue';

export default {
    components: {
        QuickpayPaymentLayout,
        QuickpayPaymentStripe,
        QuickpayPaymentOverviewDescription,
    },
    props: {
        hash: {
            type: String,
            required: true,
        },
        deadlineId: {
            type: Number,
            required: false,
            default: null,
        },
    },
    emits: ['payment-success', 'back'],
};
</script>

<style lang="scss" scoped>
.quickpay-payment-overview-card {
    &__description {
        flex-basis: 345px;
        max-width: 345px;

        @media (max-width: 1023px) {
            flex-basis: auto;
            max-width: 100%;
        }
    }

    &__provider {
        flex-basis: 500px;
        max-width: 500px;

        @media (max-width: 1023px) {
            flex-basis: auto;
            max-width: 100%;
        }
    }
}
</style>
